export default __webpack_public_path__ + "images/a964640be54333099830dc6ecb743e57.svg";